import React, {useContext, useEffect, useState} from "react";
import {isMentee, SessionContext} from "../../../Utils/sessions";
import StudentApplicantProfile from "./StudentApplicantProfile";
import {Root} from 'Root'
import MentorProfile from "./MentorProfile";
import Loading from "../../Landing/Loading";

const UserProfile = () => {
    const {session} = useContext(SessionContext)
    const [profile, setProfile] = useState(undefined)

    useEffect(() => {
        Root.userApi.getUserProfile(session.jwt).then((res) => {
            setProfile(res.data)
        }).catch(() => {
            setProfile({})
        })
    }, [session]);

    return <>
        {profile ?
            <>
                {isMentee(session) ?
                    <StudentApplicantProfile userProfile={profile} />
                    :
                    <MentorProfile userProfile={profile} />
                }
            </> :
            <Loading />
        }
    </>
}

export default (UserProfile);